export { OpeningTimesSchedule } from './OpeningTimesSchedule';
